// Populates the (mutable) name→URL map from scene.json `themes[]` and, if
// `scene.theme` names a default URL, kicks off its initial load. The map is
// what the Theme folder iterates — values flow back to applyTheme.

import type { SceneJson } from '../sceneIO/parsers';

export async function loadThemesFromScene(
    sceneConf: SceneJson,
    options: Record<string, string>,
    loadTheme: ((url: string) => Promise<unknown>) | undefined,
    opts: { debugEnabled?: boolean } = {},
): Promise<void> {
    try {
        if (!sceneConf || !Array.isArray(sceneConf['themes'])) return;
        for (const key of Object.keys(options)) delete options[key];
        (sceneConf['themes'] as Array<{ name?: string; url?: string }>).forEach((t) => {
            if (t && t.name && t.url) options[t.name] = t.url;
        });
        if (typeof sceneConf['theme'] === 'string' && typeof loadTheme === 'function') {
            await loadTheme(sceneConf['theme']);
        }
    } catch (err) {
        if (opts.debugEnabled) console.warn('Theme list load error:', err);
    }
}
